import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const getPhlebHH = createAsyncThunk(
  "schedule/getPhlebHH",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.homeHealthReportingManagers(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });
    return response;
  }
);

export const getPhlebSlice = createSlice({
  name: "getPhlebHH",
  initialState,
  reducers: {
    updatePhlebDataVal(state, action) {
      state.value = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPhlebHH.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPhlebHH.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getPhlebHH.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const getPhlebList = (state) => state.getPhlebHH.value;
export const phlebListLoading = (state) => state.getPhlebHH.loading;
export const { updatePhlebDataVal } = getPhlebSlice.actions;

export default getPhlebSlice.reducer;
